import React from 'react';
import { Checkbox } from '@framework-controls/core';
import { strings } from 'src/localization';
import * as css from './Disclaimer.module.scss';

export interface IProps {
    disclaimer?: string;
    disclaimerChecked: boolean;
    toggleDisclaimerCheck: (e: any) => void;
    requireConsent: boolean;
    requireConsentMsg: string;
    disclaimerMissing?: boolean;
}

const Disclaimer = (props: IProps) => {
    // Set the variant style to be used by the checkbox control based on if it
    // is currently checked or not.
    let cbkClassName = 'primaryCkb';
    if (props.disclaimerChecked) {
        cbkClassName = 'primaryCkbChecked';
    }

    return (
        <div className={css.disclaimer}>
            <p>{props.disclaimer}</p>
            {props.requireConsent ?
                <div
                    className={`${css.ckbarea} ${props.disclaimerMissing ? css.highlightDisclaimerConsent : ''}`}
                >
                    <Checkbox
                        id='disclaimerCheckbox'
                        size={'rg'}
                        variant={cbkClassName}
                        checked={props.disclaimerChecked}
                        onChange={(e: any) => props.toggleDisclaimerCheck(e)}
                        label={props.requireConsentMsg ? props.requireConsentMsg + ' *' : strings.ReadDisclaimer + ' *'}
                        labelPlacement='end'
                        labelClass={props.disclaimerMissing ? css.highlightDisclaimerConsent : undefined}
                    />
                </div> : null}
        </div>
    );
};

export default Disclaimer;
